import Select from '@Common/Select';
import { useGeneratorContext } from '@Context/GeneratorContext';
import { Release } from '@Models/types';
import { useEffect, useMemo, useState } from 'react';

const Releases = () => {
  const [loading, setLoading] = useState(false);
  const {
    releases,
    fetchReleases,
    selectedRelease,
    setSelectedRelease,
    selectedProduct,
  } = useGeneratorContext();

  useEffect(() => {
    if (selectedProduct) {
      setLoading(true);
      fetchReleases().then(() => setLoading(false));
    }
  }, [selectedProduct]);

  const releaseOptions = useMemo(
    () =>
      releases.map((release) => ({
        label: `${release.name} (${release.reference_num})`,
        value: release,
      })),
    [releases]
  );

  const handleReleaseChange = (
    selected: { label: string; value: Release } | null
  ) => {
    setSelectedRelease(selected?.value || null);
  };

  const placeholder =
    loading && !selectedRelease
      ? 'Loading Aha! Releases'
      : selectedRelease?.name || 'Select Aha! Release';

  return (
    <div className="flex flex-col gap-y-2 rounded-lg bg-white p-4">
      <span className="font-extrabold text-primary-700">Parking Lots</span>
      <Select
        type="release"
        options={releaseOptions}
        onChange={handleReleaseChange}
        placeholder={placeholder}
        loading={loading}
        disabled={loading}
      />
    </div>
  );
};

export default Releases;
